import {
  AddCircleOutlineOutlined,
  CheckCircleOutlineOutlined,
  ErrorOutline,
  RemoveCircleOutlineOutlined,
} from "@mui/icons-material";
import { AppendIfPrefixExists } from "../../../../modules/sitePaths";
import {
  asDto,
  BaseWidgetProps,
  ItemBox,
  ItemBoxConfiguration,
  KeyInformationWidgetContainer,
  WidgetWrapper,
} from "shared-ui";
import {
  AssetsWarehouseStockWidgetClient,
  WidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse,
} from "@lib/ShiOneClient";
import { Button } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useApi } from "../../utils";
import { useQuery } from "@tanstack/react-query";

const placeholderData = {
  success: true,
  isEmptyDataSet: false,
  data: {
    incomingAssets: 0,
    transferringAssets: 0,
    assetsAvailableToTransfer: 0,
    productsAtLevelRisk: 0,
    projectOptions: [""],
  },
};

function transformFunction(
  rawData:
    | WidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse
    | undefined,
): ItemBoxConfiguration[] {
  return [
    {
      amount: rawData?.data?.incomingAssets,
      label: "Incoming Assets",
      icon: <AddCircleOutlineOutlined fontSize={"large"} />,
    },
    {
      amount: rawData?.data?.transferringAssets,
      label: "Outgoing Assets",
      icon: <RemoveCircleOutlineOutlined fontSize={"large"} />,
    },
    {
      amount: rawData?.data?.assetsAvailableToTransfer,
      label: "Assets Available to Transfer",
      icon: <CheckCircleOutlineOutlined fontSize={"large"} />,
    },
    {
      amount: rawData?.data?.productsAtLevelRisk,
      label: "Products at Inventory Level Risk",
      icon: <ErrorOutline fontSize={"large"} color={"warning"} />,
    },
  ];
}

const useGetAssetsWarehouseWidgetData = () => {
  const api = useApi(AssetsWarehouseStockWidgetClient);

  const queryFunc = async () => {
    return await api.getAssetsWarehouseStockWidgetData("");
  };

  return useQuery({
    queryKey: ["assets-warehouse-stock-widget"],
    queryFn: queryFunc,
    placeholderData: asDto(placeholderData),
  });
};

const AssetsWarehouseStockWidget: FC<BaseWidgetProps> = ({
  pageLayoutWidget,
}) => {
  const { data, isLoading, isError, isPlaceholderData } =
    useGetAssetsWarehouseWidgetData();

  const responseData = data?.success ? transformFunction(data) : [];

  return (
    <WidgetWrapper
      pageLayoutWidget={pageLayoutWidget}
      error={isError}
      cardActions={
        <Button href={AppendIfPrefixExists("/assets/integration-center/stock")}>
          View All Stock
        </Button>
      }
    >
      <KeyInformationWidgetContainer>
        {responseData?.map((item, index) => (
          <ItemBox
            key={typeof item.label === "string" ? item.label : `label-${index}`}
            data={item.amount}
            label={item.label}
            icon={item.icon}
            loading={isPlaceholderData || isLoading}
            error={isError}
            tileActions={item.tileActions}
          />
        ))}
      </KeyInformationWidgetContainer>
    </WidgetWrapper>
  );
};

export default AssetsWarehouseStockWidget;
